import React, { useEffect } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { ContainerComponent, SearchComponent } from "./style";
import Filter from "../Filter/Filter";

const Action = ({ onFilterChange, onSearch, isDarkMode }) => {

    const handleSearchChange = (e) => {
        const searchValue = e.target.value;
        localStorage.setItem('searchTerm', searchValue);
        onSearch(searchValue);
    };

    useEffect(() => {
        const savedSearchTerm = localStorage.getItem('searchTerm');
        if (savedSearchTerm) {
            onSearch(savedSearchTerm);
        }
    }, [onSearch]);

    return (
      <>
        <ContainerComponent isDarkMode={isDarkMode}>
          <div style={{position: "relative"}}>
            <SearchOutlined style={{position: "absolute", top: "18px", left: "30px", fontSize: "20px", color: "#A7ABB7"}} />
            <SearchComponent  
              isDarkMode={isDarkMode}
              placeholder="Search for a country..."
              onChange={handleSearchChange}
              defaultValue={localStorage.getItem('searchTerm') || ''}
            />
          </div>
          <Filter isDarkMode={isDarkMode} onFilterChange={onFilterChange}/>
        </ContainerComponent>
      </>
    );
};

export default Action;